import { useEffect } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import { PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetFeesValidatorsQuery } from './store/services';
import { useLazyGetConfigurationDictionariesQuery } from '../../store/dictionaries/service';

import { FeesRoutes } from '../../routes';

import cn from './fees.module.css';

const Fees = (): React.JSX.Element => {
  const navigate = useNavigate();
  const match = useMatch(FeesRoutes.FEES);

  const { activePermissions, riskScoreRanges } = useAppSelector(
    (state) => state.configurationDictionaries,
  );

  const [getDictionaries] = useLazyGetConfigurationDictionariesQuery();
  const [getValidators] = useLazyGetFeesValidatorsQuery();

  useEffect(() => {
    if (
      activePermissions &&
      activePermissions.includes(PermissionEnum.SECTION_FEE_TARIFFS) &&
      activePermissions.includes(PermissionEnum.FEES_TYPES_LIST)
    ) {
      if (!riskScoreRanges) {
        getDictionaries();
      }

      getValidators();

      if (match) {
        navigate(FeesRoutes.FEES_LIST);
      }
    }
  }, [match, activePermissions, riskScoreRanges]);

  useEffect(() => {
    let title = 'Fee types';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.feesLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (
      !activePermissions.includes(PermissionEnum.SECTION_FEE_TARIFFS) ||
      !activePermissions.includes(PermissionEnum.FEES_TYPES_LIST)
    ) {
      content = <PermissionDenied />;
    } else {
      content = (
        <div className={cn.fees}>
          <Outlet />
        </div>
      );
    }
  }

  return content;
};

export default Fees;
